export default "/images/11891b3fd9aaf8cd478607ade3766430.avif";